import { useRef } from "react";
import MediaGallery from "@components/shared/MediaGallery";

type GalleryItem = {
  media?: { url?: string | null; contentType?: string | null } | null;
} | null;

type GalleryEntry = {
  itemsCollection?: { items: GalleryItem[] } | null;
} | null | undefined;

export const MediaGallerySection = ({ entry }: { entry: GalleryEntry }) => {
  const ref = useRef<HTMLDivElement>(null);

  if (!entry?.itemsCollection) return null;

  const slides = entry.itemsCollection.items.flatMap((i) =>
    i?.media ? [{ mediaUrl: i.media.url ?? "", contentType: i.media.contentType ?? "" }] : []
  );

  return (
    <div
      className="py-10 flex-col justify-start dsk:gap-10 relative"
      ref={ref}
    >
      <div className="overflow-hidden flex justify-center items-center h-60 dsk:h-[450px]">
        <MediaGallery
          items={slides}
          containerRef={ref}
          itemClassName="w-full h-full object-cover rounded-lg"
        />
      </div>
    </div>
  );
};
